<div class="row mt-5">
  <div class="col-md-8 col-8 mx-auto">
    <div class="row">
      <div class="col-md-3 col-8 mx-auto">
        <img src="../../assets/images/150ppi/150ppi/Web Portal-วิกฤต-ตัด-01.png" style="width: 100%;">
      </div>
      <div class="col-md-3 col-8 mx-auto">
        <img src="../../assets/images/150ppi/150ppi/Web Portal-วิกฤต-ตัด-02.png" style="width: 100%;">
      </div>
      <div class="col-md-3 col-8 mx-auto">
        <img src="../../assets/images/150ppi/150ppi/Web Portal-วิกฤต-ตัด-03.png" style="width: 100%;">
      </div>
    </div>
  </div>
</div>


// WEBPACK FOOTER //
// ./src/app/verify/verify.component.html